import { PropsWithChildren, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { createComposableProvider, i18next } from 'shared/lib';

export const TranslationsProvider = ({ children }: PropsWithChildren) => (
	<I18nextProvider i18n={i18next}>
		<Suspense fallback={null}>{children}</Suspense>
	</I18nextProvider>
);

export const withTranslations = createComposableProvider(TranslationsProvider);
